import { MedicalInformationType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { ModalCancelButton, ModalCloseButton, ModalConfirmButton } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../translations';
import { refetchAllMedicalInformation } from '../shared/refetchAllMedicalInformation';

import {
   MedicalInformationApproveDraftSubmitValues,
   useMedicalInformationApproveDraftCommand,
} from './MedicalInformationAddEntryModal.hooks';

type MedicalInformationAddEntryModalExitButtonsProps = {
   readonly onClose: VoidFunction;
   readonly shouldConfirmExit: boolean;
};

export const MedicalInformationAddEntryModalExitButtons = (
   props: MedicalInformationAddEntryModalExitButtonsProps
): JSX.Element => {
   return (
      <>
         <ModalCloseButton
            onClick={props.onClose}
            shouldConfirmExit={{
               enabled: props.shouldConfirmExit,
               title: patientMedicalInformationTranslationKeys.addEntryModal.leaveForm,
               content: patientMedicalInformationTranslationKeys.addEntryModal.confirmLeavingForm,
            }}
         />
         <ModalCancelButton
            onClick={props.onClose}
            label={patientMedicalInformationTranslationKeys.addEntryModal.cancel}
            shouldConfirmExit={{
               enabled: props.shouldConfirmExit,
               title: patientMedicalInformationTranslationKeys.addEntryModal.leaveForm,
               content: patientMedicalInformationTranslationKeys.addEntryModal.confirmLeavingForm,
            }}
         />
      </>
   );
};

type MedicalInformationAddEntryApproveDraftModalConfirmButtonProps = {
   readonly medicalInformationId: number;
   readonly medicalInformationType: MedicalInformationType;
   readonly handleSubmit: FormContextValues<MedicalInformationApproveDraftSubmitValues>['handleSubmit'];
   readonly onSuccess: (parameters: MedicalInformationApproveDraftSubmitValues) => void;
};

export const MedicalInformationAddEntryApproveDraftModalConfirmButton = (
   props: MedicalInformationAddEntryApproveDraftModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: approveMedicalInformationDraft } = useMedicalInformationApproveDraftCommand({
      medicalInformationId: props.medicalInformationId,
      medicalInformationType: props.medicalInformationType,
      onSuccess: (parameters) => {
         props.onSuccess(parameters);
         refetchAllMedicalInformation();
      },
   });
   return (
      <ModalConfirmButton
         label={patientMedicalInformationTranslationKeys.addEntryModal.addEntry}
         onClick={props.handleSubmit(approveMedicalInformationDraft)}
      />
   );
};
